import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup } from 'semantic-ui-react';
import { resourceType } from '../types';
import './styles/Resource.css';
import './styles/fonts/benton-sans-light.css';

const propTypes = {
  resource: resourceType.isRequired,
  index: PropTypes.number.isRequired,
  openResourceEditor: PropTypes.func,
  clientMode: PropTypes.bool.isRequired,
};

function getClass(str) {
  if (str === 'Online') return 'online';
  else if (str === 'On Campus') return 'on-campus';
  else if (str === 'Off Campus') return 'off-campus';
  return undefined;
}

const Resource = ({ resource, index, openResourceEditor, clientMode }) => (
  <div className={`resource-container paper ${resource.done ? '' : 'disabled-resource'}`}>
    <div
      role="button"
      tabIndex={index}
      className="resourceCard"
      onClick={() => {
        if (clientMode) {
          window.open(resource.url);
        } else openResourceEditor(resource);
      }}
    >
      <div
        alt={resource.name}
        className="headerImg"
        style={{
          backgroundImage: clientMode ?
            `url("http://www.bu.edu/globalprograms/wp-assets/media/compass/img/resource-banners/${resource.imgName}.png")`
            : `url("http://www.bu.edu/globalprograms/wp-assets/media/compass/img/resource-banners/${resource.imgName}.png"), url("http://www.bu.edu/globalprograms/wp-assets/media/compass/img/missing.png")`,
        }}
      >
        <div className="imgText">{resource.name}</div>
      </div>
      <div className={`hubCampusBanner ${getClass(resource.onCampus)}`}>{resource.onCampus}</div>
      <p>{resource.description}</p>
      <div className="iconContainer">
        <table className="inviTable iconTable">
          <tbody>
            <tr>
              <td width="12">
                <img alt="Phone Number" width="12px" src="http://www.bu.edu/globalprograms/files/2016/03/glyphicons-443-earphone.png" />
              </td>
              <td width="226">{resource.phone}</td>
              <td rowSpan="2" style={{ color: 'green', verticalAlign: 'top' }}>{resource.fee ?
                <Popup
                  trigger={<Icon circular name="dollar" />}
                  content="A fee may be associated with this resource"
                />
                : ''}</td>
            </tr>
            <tr>
              <td>
                <img alt="Email" width="12px" src="http://www.bu.edu/globalprograms/files/2016/03/glyphicons-11-envelope.png" />
              </td>
              <td>{resource.email}</td>
            </tr>
            <tr>
              <td>
                <Popup
                  trigger={<img
                    alt="Intended Population"
                    width="12px"
                    src="http://www.bu.edu/globalprograms/files/2016/03/glyphicons-4-user.png"
                  />}
                  content="Who this resource is for"
                />
              </td>
              <td colSpan="2">
                <Popup
                  trigger={<span>{resource.forStudents}</span>}
                  content="Who this resource is for"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

Resource.propTypes = propTypes;
export default Resource;



// WEBPACK FOOTER //
// ./src/components/Resource.jsx